import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

const menuItems = [
  { title: 'Usuarios', icon: '👥', route: '/admin/users', color: '#18cb96' },
  { title: 'Ganancias', icon: '💰', route: '/admin/revenue', color: '#4CAF50' },
  { title: 'Páginas', icon: '🔗', route: '/admin/pages', color: '#2196F3' },
];

const profileTypes = [
  { title: 'Barbería', icon: '✂️', color: '#FF6B6B' },
  { title: 'Centro de Estética', icon: '🌸', color: '#9B59B6' },
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <>
      <div className="admin-header">
        <h1 className="admin-title">Panel Administrador</h1>
        <button className="admin-logout" onClick={() => { logout(); navigate('/'); }}>🚪</button>
      </div>
      <div className="content-scroll">
        <div className="admin-section-label">Gestión</div>
        <div className="admin-menu-grid">
          {menuItems.map((item, i) => (
            <button key={i} className="admin-menu-card" style={{ borderColor: item.color }}
              onClick={() => navigate(item.route)}>
              <span style={{ fontSize: '40px' }}>{item.icon}</span>
              <span className="admin-menu-label">{item.title}</span>
            </button>
          ))}
        </div>
        <div className="admin-section-label">Perfiles Disponibles</div>
        <div className="admin-profiles-row">
          {profileTypes.map((p, i) => (
            <div key={i} className="admin-profile-card" style={{ borderColor: p.color }}>
              <span style={{ fontSize: '32px' }}>{p.icon}</span>
              <span className="admin-profile-label">{p.title}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
